import { unzip } from "lodash";
import { parseAntUploadFiles } from "utils/helperFuncs";

export const converterCategoriesForForm = (data, level) => {
  if (level) {
    return data?.flatMap((item) =>
      item?.children?.length
        ? item?.level === level
          ? {
              level: item.level,
              label: item.name,
              value: item.id,
              disabled: false,
              children: converterCategoriesForForm(item.children, level),
            }
          : {
              level: item.level,
              label: item.name,
              value: item.id,
              disabled: true,
              children: converterCategoriesForForm(item.children, level),
            }
        : item?.level === level && item?.isActive
          ? { level: item.level, label: item.name, value: item.id, disabled: false }
          : { level: item.level, label: item.name, value: item.id, disabled: true }
    );
  } else {
    return data?.flatMap((item) =>
      item?.children?.length
        ? {
            level: item.level,
            label: item.name,
            value: item.id,
            children: converterCategoriesForForm(item.children),
          }
        : { level: item.level, label: item.name, value: item.id }
    );
  }
};

export const converterUom = (data) =>
  data?.map((item) => {
    return {
      value: item?.id,
      label: item?.name,
    };
  });

export const converterRecommendProductName = (data) =>
  data?.map(({ id, name }) => ({ value: id, label: { nameProduct: name, quantityVariant: 10 } }));

export const convertVariantTable = (data) => {
  return data?.map((item) => ({
    image: item?.imageURLs?.[0]?.url || item?.imageURLs?.[0]?.thumbUrl || "",
    images: (item?.imageURLs || []).map((file) => file?.url || file?.thumbUrl).filter(Boolean),
    isActive: item?.isActive,
    key: item?.id || item?.key,
    name: item?.name,
    price: item?.productPrices?.price,
    priceVat: item?.productPrices?.priceVat,
    productCode: item?.code,
    vat: item?.vat,
    vatPercent: item?.vatPercent,
  }));
};

//sort products attributeValues by attribute of category
const sortByDataAttributeOfCategory = (variantAttributeValues, dataAttributeOfCategory) => {
  const filteredData = dataAttributeOfCategory?.filter((item) => item?.values?.length > 0);

  const sortedVariantAttribute =
    filteredData
      ?.map((item) => {
        return variantAttributeValues.find((variant) => item?.id === variant?.attributeID);
      })
      ?.filter((item) => item) || [];

  const attributeValue = [...sortedVariantAttribute];

  return attributeValue?.map((item) => item?.attributeValue?.id);
};

export const convertInitFormProducts = (products = [], dataAttributeOfCategory = []) => {
  return products.map((product) => ({
    ...product,
    imageURLs: parseAntUploadFiles(
      product?.imageURLs?.length ? product.imageURLs : [product?.imageURL].filter(Boolean)
    ),
    attributeValues: product?.variantAttributeValues
      ? sortByDataAttributeOfCategory(product.variantAttributeValues, dataAttributeOfCategory)
      : [],
  }));
};

//get set of attributeIDs used as variant attribute in any product
const getVariantAttributeIDsFromProducts = (products = []) =>
  new Set(products?.flatMap((product) => product?.variantAttributeValues?.map((attr) => attr?.attributeID) || []));

//convert product group attributes to it (attributes) state format
export const convertAttributesProductGroupDetail = (
  dataAttributeOfCategory = [],
  attributeValues = [],
  isNewCategory = false,
  products = []
) => {
  const variantAttributeIDs = getVariantAttributeIDsFromProducts(products);

  return dataAttributeOfCategory?.map((item) => {
    const findIndex = attributeValues?.findIndex((attr) => item?.id === attr?.attributeID);
    const currentAttributeValue = attributeValues?.at(findIndex);

    return {
      attributeID: item?.id,
      name: item?.name,
      attributeValues: item?.values || false,
      attributeValueID: isNewCategory ? currentAttributeValue?.attributeValues?.at(0)?.id : undefined,
      attributeValueIDs: isNewCategory ? currentAttributeValue?.attributeValues?.map((item) => item?.id) : [],
      isVariant: variantAttributeIDs.size
        ? variantAttributeIDs.has(item?.id)
        : currentAttributeValue?.isVariant || false,
      value: currentAttributeValue?.value,
    };
  });
};

//convert input before send to the server
export const convertProductsInput = (products = []) =>
  products.map(
    ({
      id,
      name,
      code,
      inStock = 0,
      vatPercent,
      warranty,
      productPrices,
      attributeValues = [],
      imageURLs,
      isActive,
    }) => ({
      id,
      name,
      code,
      inStock,
      vat: true,
      vatPercent,
      warranty,
      productPrices: {
        price: productPrices?.price,
        level1Price: productPrices?.price,
        level2Price: productPrices?.price,
        level3Price: productPrices?.price,
        level4Price: productPrices?.price,
      },
      attributeValues: attributeValues?.filter(Boolean),
      imageURLs,
      imageURL: imageURLs?.[0],
      isActive,
    })
  );

//convert products after attributeValues options change
export const convertProdsWithNewAttValues = (products = [], attributeValues = []) => {
  const variantAttributeValues = attributeValues?.filter((att) => att?.isVariant);

  const variantAttributeValuesOptions = variantAttributeValues?.map((att) => att?.attributeValueIDs)?.flat();

  const productsAttributeValues = products?.map((prod) => prod?.attributeValues);

  const matrixProdsAttValues =
    productsAttributeValues?.map((attValues) => {
      const newAttValues = attValues?.map((value) => {
        if (variantAttributeValuesOptions?.includes(value)) return value;
        return undefined;
      });
      return newAttValues;
    }) || [];

  const newProdsAttValuesCol = unzip(matrixProdsAttValues);

  const filteredProdsAttValuesCol = () => {
    return newProdsAttValuesCol?.filter((arr) => arr.some((item) => item));
  };

  const finalProdsAttValues = unzip(filteredProdsAttValuesCol());

  const newProducts = [
    ...products.map((item, index) => ({
      ...item,
      attributeValues: finalProdsAttValues?.at(index),
    })),
  ];

  return newProducts;
};

export const converterSuggestedProdGroup = (data) =>
  data?.map(({ id, name, totalVariation }) => ({
    value: id,
    label: { nameProduct: name, quantityVariant: totalVariation },
  }));
